var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2126 41.5432C50.0293 45.8741 48.4411 50.5449 46.9355 55.0828C46.6146 56.0609 47.1276 57.1277 48.0931 57.3911C49.0454 57.7263 50.0821 57.1853 50.389 56.2789C51.8444 51.8799 53.3679 47.3459 55.4612 43.2205C55.9119 42.3422 55.5555 41.2311 54.6607 40.7585C53.7666 40.286 52.6641 40.6651 52.2126 41.5432Z",
    fill: "#ABFF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6999 24.083C27.7295 29.9845 19.5456 37.0066 10.4013 42.7253C9.55335 43.2284 9.29035 44.3665 9.82394 45.2145C10.3582 46.0626 11.4785 46.356 12.3405 45.7813C21.5069 40.0669 29.7123 33.0491 38.7049 27.1519C39.5497 26.5738 39.784 25.4304 39.2311 24.5787C38.6649 23.7986 37.5447 23.5049 36.6999 24.083Z",
    fill: "#ABFF29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4575 4.59354C14.8073 5.2222 19.157 5.85129 23.5074 6.4801C24.4941 6.6733 25.4243 5.96282 25.5726 4.95097C25.7202 3.93898 25.0205 3.0589 24.033 2.86555C19.6761 2.23548 15.32 1.60513 10.9638 0.975201C9.96307 0.853601 9.03795 1.56479 8.89536 2.57776C8.76679 3.51913 9.45752 4.47208 10.4575 4.59354Z",
    fill: "#ABFF29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLines);
export default __webpack_public_path__ + "static/media/threeLines.1363896a7a2f2d8ab568c4236a8d159c.svg";
export { ForwardRef as ReactComponent };